import { Input, Button } from 'UI/elements';
import styles from './LoginForm.module.scss';

interface LoginFormProps {
  isLoading?: boolean;
  onSubmit: () => void;
  onChangeUsername: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePassword: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function LoginForm(props: LoginFormProps): React.ReactElement {
  const { isLoading, onSubmit, onChangeUsername, onChangePassword } = props;

  return (
    <div className={styles.form}>
      <div className={styles.formHeader}>
        <span className={styles.formHeaderTitle}>Login</span>
        <span className={styles.formHeaderSubtitle}>Please enter your credentials</span>
      </div>

      <div className={styles.formBody}>
        <Input
          onChange={onChangeUsername}
          label="Username"
          placeholder="Enter your username"
          type="text"
          id="username"
        />

        <Input
          onChange={onChangePassword}
          label="Password"
          placeholder="Enter your password"
          type="password"
          id="password"
        />

        <div className={styles.formFooter}>
          <Button onClick={onSubmit} theme="Primary" type="submit" isLoading={isLoading}>
            Log In
          </Button>
        </div>
      </div>
    </div>
  );
}
